import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { OrderTypeEnum } from "../enums/OrderEnum.js";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { DesktopTimePicker } from "@mui/x-date-pickers/DesktopTimePicker";
import Select from "react-dropdown-select";
import FormControl from "@mui/joy/FormControl";
import Radio from "@mui/joy/Radio";
import RadioGroup from "@mui/joy/RadioGroup";
import axiosInstance from "../services/axiosInstance";
import { encrypt } from "../utils/cryptoUtils.js";
import generatePDF, { Resolution, Margin } from "react-to-pdf";
import PreorderSheet from "./preorderSheet.jsx";
import OrderPopUp from "../Popup/orderPopup.jsx";

const formatDueDeliveryDate = (dueDeliveryDate) => {
  if (!dueDeliveryDate) return "";

  const date = new Date(dueDeliveryDate);

  // Extract day, month, hours, and minutes
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  // Format as dd.MM | HH:mm
  return `${day}.${month} | ${hours}:${minutes}`;
};

const AddDetails = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [pdfData, setPdfData] = useState({
    patientName: "",
    dueDate: "",
    deliveryDate: "",
  });
  const option = {
    method: "open",
    resolution: Resolution.NORMAL,
    page: {
      margin: Margin.SMALL,
      format: "A6",
      orientation: "landscape",
    },
    canvas: { mimeType: "image/png", qualityRatio: 1 },
    overrides: { canvas: { useCORS: true } },
  };

  const getTargetElement = () => document.getElementById("pre-order-sheet");
  const navigate = useNavigate();

  const [dentistList, setDentishList] = useState([]);
  const [orderTypeList, setorderTypeList] = useState([]);
  const [selectedDeliveryTime, setSelectedDeliveryTime] = useState("");
  const [holidayList, setHolidayList] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [errors, setErrors] = useState({});

  const [orderData, setOrderData] = useState({
    dentistId: 0,
    patientName: "",
    deliveryDate: "",
    orderTypeId: 0,
    isActive: true,
    createdByUserId: 1,
    lastUpdatedByUserId: 1,
  });

  useEffect(() => {
    getDetails();
    getHolidayList();
  }, []);

  const getHolidayList = async () => {
    try {
      const OrderInfo = await axiosInstance.get("/api/Order/getHolidayList");
      const holidayDateList = OrderInfo.map((x) => {
        return new Date(x.holidayYear, x.holidayMonth - 1, x.holidayDay);
      });

      setHolidayList(
        holidayDateList.map(
          (dateStr) => new Date(dateStr).toISOString().split("T")[0]
        )
      );
    } catch (error) {
      console.error("Failed to fetch user data:", error);
    }
  };

  const getDetails = async () => {
    try {
      const OrderInfo = await axiosInstance.get(
        "/api/Order/getDentailOrderInfo"
      );

      setorderTypeList(OrderInfo.orderType);
      setDentishList(OrderInfo.dentist);
    } catch (error) {
      console.error("Failed to fetch user data:", error);
    }
  };

  const handleTimeChange = (newTime) => {
    if (newTime) {
      // Extract only the time portion in HH:mm format
      const formattedTime = dayjs(newTime).format("HH:mm");
      setOrderData((prevState) => ({
        ...prevState,
        deliveryTime: formattedTime,
      }));

      setErrors((prevErrors) => {
        const { deliveryTime, ...restErrors } = prevErrors;
        return restErrors;
      });
    } else {
      setSelectedDeliveryTime(null); // Handle clearing the input
    }
  };

  const DashboardPage = () => {
    navigate("/dashboard");
  };

  const selectedValues = [" "];

  const cardStyle = {
    boxShadow: "0px 0px 8px rgba(44, 99, 152, 0.12)",
  };

  const [openPopup, setOpenPopup] = useState(false);
  const HandleRemovePopUp = () => {
    setOpenPopup(false);
     navigate("/dashboard");
  };

  const createNewOrder = async () => {
    try {
      const response = await axiosInstance.post(
        "/api/Order/createOrder",
        orderData
      );
      return response;
    } catch (error) {
      console.error("Error creating order:", error);
    }
  };

  const saveAndCreateOrder = async () => {
    const formErrors = await validateFields();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    } else {
      var response = await createNewOrder();
      setSelectedDoctor(
        dentistList.filter((x) => x.dentistId === response.dentistId)[0]
      );
      if (response !== undefined && response !== null) {
        const deliveryDate = response.deliveryDate
          ? new Date(response.deliveryDate)
          : null;
        const dueDeliveryDate = response.dueDeliveryDate
          ? new Date(response.dueDeliveryDate)
          : null;

        const formattedDeliveryDate = deliveryDate
          ? `${deliveryDate.getDate().toString().padStart(2, "0")}.${(
              deliveryDate.getMonth() + 1
            )
              .toString()
              .padStart(2, "0")}`
          : "";

        setPdfData({
          patientName: response?.patientName || "",
          dueDate: dueDeliveryDate ? dueDeliveryDate : "",
          deliveryDate: formattedDeliveryDate || "",
        });

        setOpenPopup(true);
        handleGeneratePDF();
      }
    }
  };

  const saveAndCreateOrder_Step2 = async () => {
    const formErrors = await validateFields();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    } else {
      var response = await createNewOrder();
      if (response !== undefined || response != null) {
        setSelectedDoctor(
          dentistList.filter((x) => x.dentistId === response.dentistId)[0]
        );
        const encryptedOrderId = encrypt(response.orderId);
        navigate(`/order-creation?orderId=${encryptedOrderId}`);
      }
    }
  };

  const validateFields = () => {
    const errors = {};
    if (orderData.dentistId == 0) {
      errors.dentistId = "Praxis Name erforderlich.";
    }
    if (orderData.patientName == "") {
      errors.patientName = "Patienten Name erforderlich.";
    }
    if (!orderData.deliveryDate || orderData.deliveryDate.trim() === "") {
      errors.deliveryDate = "Bitte wähle ein Lieferdatum.";
    } else {
      const [day, month, year] = orderData.deliveryDate.split("-").map(Number);
      const deliveryDate = new Date(year, month - 1, day); // Correctly parse DD-MM-YYYY

      if (isNaN(deliveryDate.getTime())) {
        errors.deliveryDate = "Ungültiges Lieferdatum";
      } else {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Reset time to 00:00:00

        if (deliveryDate < today) {
          errors.deliveryDate =
            "Das Lieferdatum darf nicht in der Vergangenheit liegen";
        }
      }
    }
    if (!orderData.deliveryTime || orderData.deliveryTime.trim() === "") {
      errors.deliveryTime = "Bitte wähle eine Uhrzeit.";
    } else {
      // Parse deliveryDate (DD-MM-YYYY) and deliveryTime (HH:mm)
      const [day, month, year] = orderData.deliveryDate.split("-").map(Number);
      const [hours, minutes] = orderData.deliveryTime.split(":").map(Number);

      // Create a new Date object by merging both
      const deliveryDate = new Date(year, month - 1, day, hours, minutes, 0, 0); // Combining date and time

      const now = new Date();

      if (isNaN(deliveryDate.getTime())) {
        errors.deliveryTime = "Ungültige Lieferzeit";
      } else if (deliveryDate < now) {
        errors.deliveryTime = "Delivery Time cannot be in the past.";
      }
    }

    if (orderData.orderTypeId == 0) {
      errors.orderTypeId = "Bitte wähle eine Auftragsart.";
    }

    return errors;
  };

  const handleGeneratePDF = () => {
    setIsVisible(true);
    setTimeout(() => {
      generatePDF(getTargetElement, option);
      setIsVisible(false);
    }, 100);
  };

  return (
    <div className="">
      <style>
        {`
          #pre-order-sheet.hidden {
            display: none;
          }
        `}
      </style>
      <div
        className="relative rounded-[20px] bg-blue-400 mt-5
      before:content-[''] before:bottom-0 before:left-0 before:w-[240px] before:h-full before:bg-cover before:bg-left-bottom before:bg-no-repeat before:absolute before:bg-[url('./assets/images/round_border_bg_left.svg')] before:hidden lg:before:block
      after:content-[''] after:top-0 after:right-0 after:w-[308px] after:h-[540px] after:bg-cover after:bg-right-top after:bg-no-repeat after:absolute after:bg-[url('./assets/images/round_border_bg_right.svg')] after:hidden lg:after:block z-0
     "
        style={cardStyle}
      >
        <div className="bg-blue p-4 text-center rounded-t-[20px]">
          <h1 className="text-5xl xl:text-4xl 3xl:text-5xl text-white font-robotoBold">
            Auftragsdetails
          </h1>
        </div>
        <div className="py-14 xl:py-10 3xl:py-14">
          <form className="2xl:w-7/12 lg:w-2/3 w-4/5 mx-auto z-10 relative">
            <div className="mb-5 font-inter relative">
              <label
                className="block text-gray-600 text-2xl xl:text-base 3xl:text-3xl font-medium mb-2"
                htmlFor="options"
              >
                Praxis
                <sup className="text-red">*</sup>
              </label>

              <Select
                className="appearance-none !border h-12 xl:h-10 3xl:h-12 !border-gray !leading-relaxed !text-2xl xl:!text-sm 3xl:!text-2xl bg-white !rounded-lg !w-full 2xl:min-w-[250px] !py-3 !px-5 xl:!py-2 xl:!px-3 3xl:!py-3 3xl:!px-5 text-gray-600 placeholder:!text-2xl xl:placeholder:!text-sm 3xl:placeholder:!text-2xl placeholder:!text-gray-400 hover:!border-blue-600 focus:!border-blue-600 focus:!outline-none !shadow-none"
                options={dentistList}
                labelField="dentistDisplayName"
                valueField="dentistDisplayName"
                placeholder="Praxis"
                values={dentistList.filter((data) =>
                  selectedValues.includes(data.dentistDisplayName)
                )}
                onChange={(selectedOptions) => {
                  if (selectedOptions[0]?.dentistId) {
                    const selectedDentistId = selectedOptions[0]?.dentistId;
                    setOrderData((prevState) => ({
                      ...prevState,
                      dentistId: selectedDentistId,
                    }));
                  }
                  setErrors((prevErrors) => {
                    const { dentistId, ...restErrors } = prevErrors;
                    return restErrors;
                  });
                }}
              />
              {/* Error message for dentistId */}
              {errors.dentistId && (
                <p className="text-red text-sm mt-1">{errors.dentistId}</p>
              )}
            </div>
            <div className="mb-5 font-inter">
              <label
                className="block text-gray-600 text-2xl xl:text-sm 3xl:text-2xl mb-2"
                Hrmlfor="id"
              >
                Patient
                <sup className="text-red">*</sup>
              </label>
              <input
                className="appearance-none border h-12 xl:h-10 3xl:h-12 !border-gray rounded-lg w-full !py-3 !px-5 xl:!py-2 xl:!px-3 3xl:!py-3 3xl:!px-5 text-gray-600 placeholder:!text-gray-400 hover:!border-blue-600 focus:!border-blue-600 focus:!outline-none focus:!shadow-outline"
                id="username"
                type="text"
                placeholder="Patient"
                value={orderData.patientName}
                onChange={(event) => {
                  setOrderData((prevState) => ({
                    ...prevState,
                    patientName: event.target.value,
                  }));
                  setErrors((prevErrors) => {
                    const { patientName, ...restErrors } = prevErrors;
                    return restErrors;
                  });
                }}
              />
              {/* Error message for Patient Name */}
              {errors.patientName && (
                <p className="text-red text-sm mt-1">{errors.patientName}</p>
              )}
            </div>
            <div className="relative mb-5 font-inter">
              <label
                htmlFor="date"
                className="block text-gray-600 text-2xl xl:text-sm 3xl:text-2xl font-medium mb-2"
              >
                Lieferdatum
                <sup className="text-red">*</sup>
              </label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <div className="!w-full !min-w-full">
                  <DemoItem>
                    <DesktopDatePicker
                      className="width-full appearance-none bg-white !border !border-gray !rounded-lg !w-full !min-w-full !text-gray-600 placeholder:!text-gray-400 focus:!border-blue-600 placeholder:!text-2xl hover:!border-blue-600 focus:!outline-none focus:!shadow-outline flex items-center justify-between"
                      disablePast
                      shouldDisableDate={(date) => {
                        const day = date.day(); // 0 = Sunday, 6 = Saturday
                        const formattedDate = date.toISOString().split("T")[0];
                        return (
                          day === 0 ||
                          day === 6 ||
                          holidayList.includes(formattedDate)
                        );
                      }}
                      onChange={(newDate) => {
                        const date = new Date(newDate);
                        const day = String(date.getDate()).padStart(2, "0");
                        const month = String(date.getMonth() + 1).padStart(
                          2,
                          "0"
                        );
                        const year = date.getFullYear();
                        const formattedDate = `${day}-${month}-${year}`;
                        setOrderData((prevState) => ({
                          ...prevState,
                          deliveryDate: formattedDate,
                        }));

                        setErrors((prevErrors) => {
                          const { deliveryDate, ...restErrors } = prevErrors;
                          return restErrors;
                        });
                      }}
                      slotProps={{
                        textField: {
                          onKeyDown: (e) => e.preventDefault(), // Blocks keyboard input
                        },
                      }}
                    />

                    {/* Error message for Delivery Date */}
                    {errors.deliveryDate && (
                      <p className="text-red text-sm mt-1">
                        {errors.deliveryDate}
                      </p>
                    )}
                  </DemoItem>
                </div>
              </LocalizationProvider>
            </div>
            <div className="relative mb-5 font-inter">
              <label
                htmlFor="date"
                className="block text-gray-600 text-2xl xl:text-sm 3xl:text-2xl font-medium mb-2"
              >
                Uhrzeit
                <sup className="text-red">*</sup>
              </label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoItem>
                  <DesktopTimePicker
                    onChange={handleTimeChange} // Update state with only time
                    views={["hours"]}
                    ampm={false}
                    responsive={false}
                    slotProps={{ textField: { readOnly: true } }}
                    className="width-full appearance-none bg-white !border !border-gray !rounded-lg !w-full !min-w-full !text-gray-600 placeholder:!text-gray-400 focus:!border-blue-600 hover:!border-blue-600 placeholder:!text-2xl focus:!outline-none focus:!shadow-outline flex items-center justify-between"
                  />
                  {/* Error message for Delivery Time */}
                  {errors.deliveryTime && (
                    <p className="text-red text-sm mt-1">
                      {errors.deliveryTime}
                    </p>
                  )}
                </DemoItem>
              </LocalizationProvider>
            </div>
            <div className="relative mb-5 font-inter">
              <FormControl>
                <label className="block text-gray-600 text-2xl xl:text-sm 3xl:text-2xl font-medium mb-2">
                  Auftragsart
                  <sup className="text-red">*</sup>
                </label>
                {/* Error message for Delivery Date */}
                {errors.orderTypeId && (
                  <p className="text-red text-sm mt-1">{errors.orderTypeId}</p>
                )}
                <RadioGroup
                  defaultValue="type1"
                  name="controlled-radio-buttons-group"
                  orientation="horizontal"
                  className="gap-5 xl:gap-4 3xl:gap-5"
                  sx={{
                    gap: "20px",
                    flexWrap: "wrap",
                    margin: "0",
                    justifyContent: "space-between",
                    color: "gray-600 !important",
                  }}
                >
                  {orderTypeList.map((data, index) => (
                    <Radio
                      key={index}
                      className="!m-0 !text-gray-600 !font-interRegular text-2xl xl:!text-base 3xl:!text-2xl"
                      value={data.orderTypeId}
                      label={data.orderTypeName}
                      onClick={(event) => {
                        setOrderData((prevState) => ({
                          ...prevState,
                          orderTypeId: parseInt(event.target.value),
                        }));
                        setErrors((prevErrors) => {
                          const { orderTypeId, ...restErrors } = prevErrors;
                          return restErrors;
                        });
                      }}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </div>
          </form>
        </div>
      </div>
      <div className="pb-12 2xl:mp-0 flex items-center justify-end gap-5 mt-5">
        <button
          className="px-5 py-2 text-2xl xl:!text-base 3xl:!text-2xl border uppercase border-blue-500 text-blue font-robotoBold rounded-lg hover:bg-blue-800 hover:border-blue-800 hover:text-white transition duration-300"
          onClick={DashboardPage}
        >
          Abbrechen
        </button>
        {orderData?.orderTypeId == OrderTypeEnum?.SIMPLE_ORDER_TYPE ? (
          <button
            onClick={saveAndCreateOrder_Step2}
            className="text-2xl xl:!text-base 3xl:!text-2xl bg-blue  uppercase border border-blue hover:bg-blue-800 hover:border-blue-800 text-white font-robotoBold py-2 px-5 rounded-lg focus:outline-none focus:shadow-outline transition-all ease-in"
            type="button"
          >
            Weiter
          </button>
        ) : (
          <button
            onClick={saveAndCreateOrder}
            className="text-2xl xl:!text-base 3xl:!text-2xl bg-blue uppercase border border-blue hover:bg-blue-800 hover:border-blue-800 text-white font-robotoBold py-2 px-5 rounded-lg focus:outline-none focus:shadow-outline transition-all ease-in"
            type="button"
          >
            Speichern
          </button>
        )}
      </div>
      <OrderPopUp openPopUp={openPopup} closePopUp={HandleRemovePopUp} />

      <PreorderSheet
        pdfData={pdfData}
        formatDueDeliveryDate={formatDueDeliveryDate}
        isVisible={isVisible}
        selectedDoctor={selectedDoctor}
      />
    </div>
  );
};

export default AddDetails;
